import React from 'react'
import { Col, Row } from 'rsuite'
import ProgressDataCard from './ProgressDataCard'
import ClusterChart from './ClusterChart'
import DashboradToggle from '../DashboradToggle'

export default function ProjectCharts({ schema, ...props }) {
  const { isSetting, isShow, onSettingChange, dashboradName } = props

  return (
    schema && (
      <div>
        <Row>
          {schema.clusterList?.map((item) => (
            <Col xs={24} sm={12} md={8} lg={6}>
              {isSetting && (
                <DashboradToggle
                  onChange={onSettingChange}
                  dashboradName={dashboradName}
                  checked={isShow}
                />
              )}
              <div style={{ marginRight: 10 }}>
                <ClusterChart schema={item} />
              </div>
            </Col>
          ))}
        </Row>

        {schema.details?.map((item) => (
          <Row style={{ marginTop: 10 }}>
            {isSetting && (
              <DashboradToggle
                onChange={onSettingChange}
                dashboradName={dashboradName}
                checked={isShow}
              />
            )}
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={4}
              align="center"
              style={{ paddingLeft: 10, marginBottom: 10 }}
            >
              <br />
              <div style={{ ...clusterDivStyle, backgroundColor: item.color }}>
                <p style={clusterTextStyle}>
                  <b>{item.name}</b>
                </p>
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={20} style={{ marginBottom: 10 }}>
              {/* <Row> */}
              <Col xs={24} sm={12} md={6} lg={6}>
                <div style={{ paddingLeft: 10, textAlign: 'center' }}>
                  <b>--- {item.processingLabel} ---</b>
                  <ProgressDataCard schema={item.processing} bgcolor={bgcolor} />
                </div>
              </Col>
              <Col xs={24} sm={12} md={6} lg={6}>
                <div style={progressDivStyle}>
                  <b>--- {item.delayedLabel} ---</b>
                  <ProgressDataCard schema={item.delayed} bgcolor={bgcolor} />
                </div>
              </Col>
              <Col xs={24} sm={12} md={6} lg={6}>
                <div style={progressDivStyle}>
                  <b>--- {item.closedLabel} ---</b>
                  <ProgressDataCard schema={item.closed} bgcolor={bgcolor} />
                </div>
              </Col>
              <Col xs={24} sm={12} md={6} lg={6}>
                <div style={progressDivStyle}>
                  <b>--- {item.totalLabel} ---</b>
                  <ProgressDataCard schema={item.total} bgcolor={bgcolor} />
                </div>
              </Col>
              {/* </Row> */}
            </Col>
          </Row>
        ))}
      </div>
    )
  )
}

const bgcolor = '' //'#2da888'
const progressDivStyle = {
  paddingLeft: 10,
  textAlign: 'center',
}
const clusterTextStyle = {
  fontSize: '2rem',
  color: '#fff',
  paddingTop: 20,
  paddingBottom: 20,

  display: 'table-cell',
  verticalAlign: 'middle',
  textAlign: 'center',
}

const clusterDivStyle = {
  display: 'table',
  width: '100%',
  // height: '100%',
  borderRadius: 10,
  //textAlign: 'center',
  // width: '100%',
  height: 160,
  marginTop: 10,
}
